
export default {
    props: ['menu', 'data']
}
